module.exports = {"TXTCLI_Create_Club":{"id":"TXTCLI_Create_Club","defaultMessage":"クラブを開設","track":"Create Club"}}